import { DOC_FLOW_FORM_FIELD_TYPE } from '../DocFlow.constants'
import { getDocFlowDefaultMappingType } from '../DocFlow.utils.mapping'

export function getEditTypeFieldsInitialValues(type, t) {
  return {
    [DOC_FLOW_FORM_FIELD_TYPE]: type || getDocFlowDefaultMappingType(t),
  }
}
